import ArrowRight from "icons/dashboard/ArrowRight";
import React from "react";
import { BreadCrumbsSteps } from "types/common";

interface BreadCrumbsProps {
  handleOnClick: (id: number) => void;
  steps: BreadCrumbsSteps[];
  currentStep: number;
}
const BreadCrumbs = (props: BreadCrumbsProps) => {
  const { steps, currentStep, handleOnClick } = props;
  return (
    <div className="w-full flex lg:gap-2 gap-[2px] items-center flex-wrap">
      {steps &&
        steps?.length > 0 &&
        steps?.map((item: BreadCrumbsSteps, index: number) => {
          if (currentStep < item.id) {
            return null;
          } else {
            return (
              <React.Fragment key={index}>
                <span
                  className={`lg:text-base text-sm leading-[20.83px]  ${
                    item.id !== 0 && "cursor-pointer hover:!text-txtPrimary"
                  } ${
                    item.id === currentStep
                      ? "text-txtPrimary"
                      : "text-txtParagraph"
                  }`}
                  onClick={() => {
                    if (item.id !== 0) {
                      handleOnClick(item.id);
                    }
                  }}
                >
                  {item.title}
                </span>
                {item.id !== currentStep && <ArrowRight />}
              </React.Fragment>
            );
          }
        })}
    </div>
  );
};

export default BreadCrumbs;
